import React from "react";
import { AppShell, Group, Skeleton } from "@mantine/core";
import { HEADER_HEIGHT } from "../utils/constants";
import { useMediaQuery } from "@mantine/hooks";

function LoadingLayout() {
  const isSmallScreen = useMediaQuery("(max-width: 1100px)");
  return (
    <AppShell header={{ height: HEADER_HEIGHT }}>
      <AppShell.Header>
        <Group justify="space-between" align="center" h="100%" px="md">
          <Group gap="xs">
            <Skeleton width={100} height={25} />
            {!isSmallScreen && <Skeleton width={200} height={25} />}
          </Group>
          <Group gap="xs">
            {!isSmallScreen && <Skeleton width={60} height={25} />}
            <Skeleton height={25} circle />
          </Group>
        </Group>
      </AppShell.Header>
    </AppShell>
  );
}

export default LoadingLayout;
